import React, {useState} from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import {notifyUser} from "../../../util/util";
import {serverRequest} from "../../../util/server_request";
import {Spin} from "antd";
import secureLocalStorage from "react-secure-storage";

export const PinVerifyFP = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const phone = location.state?.phone;
    const otp = location.state?.otp;

    const [pin, setPin] = useState('')
    const [loading, setLoading] = useState(false)

    const toggleLoading = () => setLoading(prevState => !prevState)

    const changeHandler = (e) => setPin(e.target.value)

    const verifyOTP = () => {
        if (pin === '' || pin === null){
            return notifyUser('error', 'Please enter PIN to proceed!', 'Validation Error');
        }
        toggleLoading()
        serverRequest('POST', `auth/verify/account/pin`, {phone, pin}, true, otp)
            .then(result =>{
                toggleLoading()
                if (!result?.success){
                    notifyUser('error', result?.message, 'Error')
                }else{
                    secureLocalStorage.setItem('token', result?.data.jwt)
                    notifyUser('success', 'Your pin was verified successfully!', 'Pin Confirm')
                    navigate('/forgot-password/create-password', {state: {phone}})
                }
            }).catch(error => {
            toggleLoading()
            notifyUser('error', error.message, 'Error')
        })
    }


    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Confirm your PIN </p>
                <small className='text-center'>Enter your PIN connected to {phone}</small>

                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <omk-otp-field
                            number-of-inputs="4"
                            resend-text=""
                            resend-button-label=""
                            label="Enter PIN"
                            className='mb-2' value={pin} onInput={changeHandler} />

                        <p className="text-center omk-text-small text-black-50 mb-5"><i className="bi bi-shield-lock"/> Your information is confidential and secure</p>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={verifyOTP}>Continue</button>
                    </div>
                </Spin>
            </div>
        </div>
    )
}